const fr = {
  services: {
    seoTitle: "Services · Hôtel Ciutat Martorell à Martorell",
    seoDesc: "Tous les services de l'hôtel et des chambres : Business Corner, restaurant My Bar, parking, salle de sport, WiFi gratuit, réception 24h et bien plus.",
    eyebrow: "Services",
    title: "Tout ce qu'il vous faut pour un séjour confortable",
    hotelTitle: "Services de l'hôtel",
    hotel: [
      "Climatisation et chauffage",
      "Ascenseurs",
      "Buffet petit-déjeuner quotidien",
      "Business Corner",
      "Consigne à bagages",
      "Salle de sport",
      "Matériel audiovisuel",
      "Parking",
      "Réception 24h",
      "Restaurant My Bar, ouvert tous les jours pour déjeuner et dîner",
      "Service en chambre 24h",
      "Salles de réunion et de banquet",
      "Service de blanchisserie / pressing",
      "Service d'impression",
      "WiFi gratuit",
    ],
    roomsTitle: "Dans la chambre",
    rooms: [
      "Adaptées aux personnes à mobilité réduite",
      "Climatisation et chauffage individuels",
      "Produits d'accueil dans la salle de bain",
      "Salle de bain complète avec douche ou baignoire et/ou bidet",
      "Bureau",
      "Minibar",
      "Sèche-cheveux",
      "Téléviseur à écran plat avec entrée USB",
      "Téléphone dans la chambre et la salle de bain",
      "WiFi gratuit",
      "Lit bébé disponible",
      "Lit d'appoint",
      "Chambres non-fumeurs",
    ],
    fitness: {
      eyebrow: "Salle de sport",
      title: "Salle de fitness",
      text: "Gardez votre routine pendant votre séjour dans notre salle de fitness, équipée d'un tapis de course, d'un vélo d'appartement et d'haltères.",
      alts: ["Salle de fitness avec vélo d'appartement, tapis de course et serviettes", "Salle de fitness avec tapis de course, vélo et haltères face au miroir"],
    },
    shop: {
      eyebrow: "Produits officiels",
      title: "La passion du football, à la réception",
      text: "À notre réception, vous trouverez des produits officiels du FC Barcelone et du Real Madrid. Emportez la passion de votre équipe avec vous.",
      note: "Vente uniquement à la réception",
      cta: "Renseignez-vous à la réception",
      clubs: [
        { name: "FC Barcelone", items: "Maillots, casquettes, écharpes, sacs à dos, ballons et bien plus." },
        { name: "Real Madrid", items: "Maillots, tenues, casquettes, ballons, écharpes et bien plus." },
      ],
    },
  },
  nav: {
    nye: "Nouvel An 2026",
    hotel: "L'Hôtel",
    rooms: "Chambres",
    services: "Services",
    corporate: "Entreprises & Salles",
    events: "Événements & Mariages",
    restaurant: "Restaurant",
    location: "Emplacement",
    biosphere: "Durabilité",
    gallery: "Galerie",
    blog: "Blog",
    contact: "Contact",
    book: "Réserver en direct",
    menu: "Menu",
    close: "Fermer",
    call: "Appeler",
    map: "Carte",
    bookShort: "Réserver",
  },
  hero: {
    availability: "Vérifier la disponibilité",
    checkin: "Arrivée",
    checkout: "Départ",
    adults: "Adultes",
    children: "Enfants",
    promo: "Code promo",
    promoPlaceholder: "Facultatif",
    bestPrice: "Meilleur prix garanti en réservant ici",
    scroll: "Défiler",
  },
  attrs: [
    { t: "Meilleur prix garanti", d: "En réservant en direct" },
    { t: "Annulation flexible", d: "Selon le tarif" },
    { t: "Petit-déjeuner buffet", d: "De 6 h 30 à 10 h 30" },
    { t: "Parking privé", d: "Avec supplément, selon disponibilité" },
    { t: "100 m de Renfe & FGC", d: "30 min de Barcelone" },
  ],
  marquee: ["Martorell", "30 min Barcelone", "Montserrat", "Renfe & FGC à 100 m", "Zone d'affaires SEAT-CUPRA", "Confort 4 étoiles", "92 chambres", "Réservation directe"],
  home: {
    presEyebrow: "L'hôtel",
    stats: [
      { n: "92", l: "chambres standard" },
      { n: "100 m", l: "de Renfe et FGC" },
      { n: "30 min", l: "de Barcelone et de l'aéroport" },
      { n: "180", l: "personnes dans la salle principale" },
    ],
    roomsEyebrow: "Chambres",
    roomsTitle: "Un repos sur mesure",
    roomsText: "Deux types de chambres pensées pour le voyageur d'affaires, les familles et les longs séjours.",
    roomsCta: "Voir toutes les chambres",
    from: "À partir de",
    detail: "Voir le détail",
    corpEyebrow: "Entreprises & réunions",
    corpTitle: "Un hub d'affaires|à 5 minutes de SEAT-CUPRA",
    corpFeatures: ["3 salles de réunion", "Jusqu'à 180 personnes", "Connexion WiFi et matériel audiovisuel", "Pauses café et déjeuners d'affaires"],
    corpCta: "Demander un devis",
    corpSecondary: "Voir les salles",
    restEyebrow: "Gastronomie",
    restCta: "Découvrir le restaurant",
    locEyebrow: "Emplacement",
    locCta: "Comment venir",
    galleryEyebrow: "Galerie",
    galleryCta: "Voir la galerie complète",
    directEyebrow: "Réservation directe",
    directTitle: "Réserver ici est toujours avantageux",
    directItems: [
      { t: "Meilleur prix en ligne", d: "Aucune agence ne vous proposera un tarif plus bas que notre site." },
      { t: "Conditions flexibles", d: "Tarifs avec annulation gratuite et paiement à l'hôtel." },
      { t: "Contact direct", d: "Vous parlez avec l'équipe de l'hôtel, sans intermédiaires, avant et après votre séjour." },
      { t: "Attentions de bienvenue", d: "Départ tardif selon disponibilité et avantages exclusifs pour les clients en direct." },
    ],
    testimonialsEyebrow: "Avis",
    testimonials: [
      { q: "Emplacement parfait pour travailler dans la zone industrielle. Chambres calmes et petit-déjeuner complet. Nous revenons chaque mois.", a: "Marc V.", r: "Voyage d'affaires" },
      { q: "Nous avons célébré la communion de notre fille dans la salle et tout était impeccable. L'équipe s'est occupée de chaque détail.", a: "Laura & Jordi", r: "Célébration familiale" },
      { q: "Train à 2 minutes à pied et Barcelone en une demi-heure. Une base calme et bien entretenue pour visiter la ville et Montserrat.", a: "Claire D.", r: "Escapade" },
    ],
    contactEyebrow: "Parlons-en",
    contactCta: "Nous contacter",
    rfpCta: "Demander un devis",
  },
  rooms: {
    eyebrow: "Chambres",
    surface: "Surface",
    occupancy: "Occupation",
    bed: "Lit",
    bath: "Salle de bain",
    features: "Équipements",
    guests: "personnes",
    book: "Réserver cette chambre",
    all: "Toutes les chambres",
    photosEyebrow: "Galerie",
    photosTitle: "Chambre et salle de bain",
    photosCount: "photos",
    featureLabels: {
      wifi: "Wi-Fi haut débit",
      ac: "Climatisation",
      tv: "TV",
      desk: "Bureau de travail",
      minibar: "Minibar",
      hairdryer: "Sèche-cheveux",
      crib: "Lit bébé disponible",
      extra_bed: "Lit d'appoint",
      accessible: "Accessible",
      nonsmoking: "Non-fumeur",
    },
    servicesEyebrow: "Services",
    family: {
      eyebrow: "Vous voyagez en famille",
      title: "Options familiales",
      beds: { t: "Lit supplémentaire (triple)", d: "Transformez votre chambre en triple avec un lit supplémentaire. Gratuit pour les enfants de moins de 12 ans." },
      crib: { t: "Lit bébé gratuit", d: "Lits bébé disponibles sans frais pour les tout-petits." },
      note: "Les deux options sont soumises à disponibilité ; demandez-les à l'avance lors de la réservation.",
    },
    servicesTitle: "Nous avons tout ce dont vous avez besoin",
    services: [
      { t: "Petit-déjeuner buffet", d: "Produits locaux, viennoiseries artisanales et options saines chaque matin." },
      { t: "Parking privé", d: "Avec supplément, selon disponibilité." },
      { t: "Wi-Fi fibre", d: "Connexion symétrique dans tout l'hôtel, sans frais supplémentaires." },
      { t: "Réception 24 h", d: "Équipe disponible à toute heure pour ce dont vous avez besoin." },
      { t: "Salle de fitness", d: "Gardez votre routine pendant votre séjour." },
      { t: "Restaurant & bar", d: "Menu d'affaires, carte méditerranéenne et verres tranquilles." },
    ],
    notFound: "Chambre introuvable",
  },
  corporate: {
    eyebrow: "Entreprises",
    title: "Votre base d'opérations dans le corridor industriel du Llobregat",
    pillars: [
      { t: "Tarifs entreprises", d: "Prix négociés pour les entreprises avec séjours fréquents et facturation centralisée." },
      { t: "Salles de réunion", d: "Trois espaces modulables, de 12 à 180 personnes." },
      { t: "Travailler et se reposer", d: "Bureau dans chaque chambre, Wi-Fi et petit-déjeuner dès la première heure." },
      { t: "Traiteur d'affaires", d: "Pauses café, déjeuners de travail et dîners d'équipe au sein de l'hôtel." },
    ],
    salasEyebrow: "Salles de réunion",
    photosTitle: "Salle et événements",
    salasTitle: "Des espaces qui s'adaptent à votre agenda",
    salasCta: "Voir toutes les salles et capacités",
    formEyebrow: "Tarif entreprise",
    formTitle: "Demandez votre tarif entreprise",
    formText: "Dites-nous combien de nuits par an votre équipe a besoin et nous préparerons une proposition en moins de 24 heures.",
    capacityTitle: "Capacités par configuration",
    capacityLabels: { teatro: "Théâtre", escuela: "Classe", u: "En U", imperial: "Impérial", coctel: "Cocktail", banquete: "Banquet" },
    equipmentLabels: {
      wifi: "Wi-Fi fibre", proyector: "Projecteur & écran", flipchart: "Paperboard", pizarra: "Tableau blanc",
      coffee_break: "Pause café", agua: "Eau minérale", escritura: "Matériel d'écriture", luz_natural: "Lumière naturelle", panelable: "Cloisonnable",
    },
    area: "Surface",
    people: "pers.",
    upTo: "Jusqu'à",
    requestRoom: "Demander un devis pour cette salle",
    salasIntro: "Toutes les salles disposent du Wi-Fi fibre, d'une climatisation indépendante, d'équipements audiovisuels et d'un service de pause café. Nous vous aidons à choisir la configuration idéale.",
    servicesTitle: "Services pour votre événement",
    services: ["Pause café de bienvenue et de milieu de matinée", "Déjeuner d'affaires ou buffet de travail", "Hébergement pour intervenants et participants", "Parking pour les participants", "Support technique pendant l'événement", "Secrétariat et matériel d'écriture"],
    otherRooms: "Autres salles",
    notFound: "Salle introuvable",
  },
  events: {
    eyebrow: "Événements & célébrations",
    title: "Les grands jours méritent un lieu à la hauteur",
    intro: "Mariages, communions, anniversaires et rencontres de groupe dans une salle de 220 m² avec lumière naturelle, cuisine maison et 92 chambres pour que personne n'ait à rentrer en voiture.",
    types: [
      { key: "weddings", t: "Mariages", d: "Banquets jusqu'à 150 invités, cocktail de bienvenue et suite nuptiale offerte.", cta: "Découvrir les mariages" },
      { key: "celebrations", t: "Célébrations", d: "Communions, baptêmes, anniversaires avec des menus sur mesure pour tous les âges.", cta: "Voir les célébrations" },
      { key: "groups", t: "Groupes", d: "Équipes sportives, voyages organisés et pèlerins de Montserrat avec conditions spéciales.", cta: "Groupes & voyages" },
    ],
    stepsEyebrow: "Comment nous procédons",
    steps: [
      { t: "Nous faisons connaissance", d: "Visite de l'hôtel, nous écoutons votre idée et proposons espaces et menus." },
      { t: "Proposition sur mesure", d: "Devis ferme en 48 h, sans surprises, avec dégustation préalable pour les mariages." },
      { t: "Le grand jour", d: "Un coordinateur dédié gère les horaires et les prestataires pour que vous n'ayez qu'à profiter." },
    ],
    formEyebrow: "Parlez-nous de votre événement",
    formTitle: "Commençons à le planifier",
    weddings: {
      title: "Mariages à Martorell, à une demi-heure de Barcelone",
      intro: "Une salle cloisonnable avec lumière naturelle pour le banquet, une terrasse pour le cocktail et des chambres pour les mariés et leurs invités. Cuisine méditerranéenne maison et un coordinateur dédié du premier café à la dernière danse.",
      includes: ["Cocktail de bienvenue", "Banquet avec menu dégustation préalable", "Suite nuptiale offerte", "Tarifs spéciaux pour les invités", "Bar ouvert et DJ en option"],
    },
    celebrations: {
      title: "Communions, baptêmes et anniversaires",
      intro: "Célébrations familiales avec des menus pensés pour petits et grands, espace pour l'animation des enfants et la tranquillité de tout avoir sous le même toit.",
      includes: ["Menus enfants et adultes", "Espace pour l'animation", "Décoration sur mesure", "Gâteau personnalisé", "Coin photos", "Chambres pour la famille"],
    },
    groups: {
      title: "Groupes, équipes et voyages organisés",
      intro: "Hébergement pour groupes de 10 à 180 personnes avec petit-déjeuner anticipé, dîners de groupe et enregistrement rapide. Le point de départ idéal pour Montserrat et Barcelone.",
      includes: ["Tarifs de groupe à partir de 10 chambres", "Petit-déjeuner anticipé sur demande", "Dîners et pique-niques de groupe", "Enregistrement collectif"],
    },
    includesTitle: "Inclus dans la proposition",
    back: "Tous les événements",
  },
  restaurant: {
    eyebrow: "My Bar",
    title: "Cuisine méditerranéenne de marché",
    hoursTitle: "Horaires",
    breakfast: "Petit-déjeuner",
    lunch: "Déjeuner",
    dinner: "Dîner",
    menuEyebrow: "Offres",
    menus: [
      { t: "Petit-déjeuner buffet", d: "Viennoiseries artisanales, fruits frais, charcuterie catalane, œufs à la demande et café de spécialité.", p: "06:30 – 10:30" },
      { t: "Menu d'affaires", d: "Du lundi au vendredi à midi. Trois plats de marché avec pain, boisson et café.", p: "Prix sur demande" },
      { t: "Carte méditerranéenne", d: "Riz, poisson du jour, viandes grillées et desserts maison avec vins du Penedès.", p: "Dîners et week-ends" },
      { t: "Menus de groupe", d: "Propositions fixes pour entreprises, célébrations et groupes de voyage à partir de 10 convives.", p: "Sur mesure" },
    ],
    reserveTitle: "Réserver une table",
    reserveText: "Appelez-nous et nous confirmons votre table immédiatement.",
    reserveCta: "Appeler le restaurant",
    reserveTap: "Touchez pour appeler",
    wineEyebrow: "Cave",
    wineTitle: "Vins du Penedès et de toute la Catalogne",
    wineText: "Une carte courte et honnête qui privilégie les petits domaines de la région : cavas, xarel·los et grenaches pour accompagner la cuisine de saison.",
  },
  location: {
    eyebrow: "Emplacement & connectivité",
    title: "Au centre de tout ce qui compte",
    pois: [
      { name: "Gare Renfe / FGC Martorell Enllaç", dist: "100 m", time: "2 min à pied", mode: "walk" },
      { name: "Siège SEAT-CUPRA et parcs industriels", dist: "2,5 km", time: "5 min en voiture", mode: "car" },
      { name: "Monastère et Parc Naturel de Montserrat", dist: "19 km", time: "20 min en voiture / crémaillère", mode: "car" },
      { name: "Centre de Barcelone (Pl. Espanya / Catalunya)", dist: "28 km", time: "30 min en train direct ou A-2", mode: "train" },
      { name: "Aéroport Barcelone-El Prat (BCN)", dist: "32 km", time: "25 min par autoroute", mode: "plane" },
      { name: "Circuit de Barcelona-Catalunya", dist: "45 km", time: "40 min par AP-7", mode: "car" },
    ],
    faqEyebrow: "Questions fréquentes",
    faqTitle: "Comment venir et se déplacer",
    mapCta: "Ouvrir dans Google Maps",
    addressTitle: "Adresse",
    transportTitle: "Transport",
    transportItems: [
      { t: "En train", d: "Renfe R4 et FGC (Martorell Enllaç / Martorell Central) à 100 m. Barcelone en 30 min." },
      { t: "En voiture", d: "Sorties directes depuis l'A-2 (sortie 585 Martorell) et l'AP-7 (sortie 25 Martorell)." },
      { t: "Depuis l'aéroport", d: "25 minutes par autoroute. Taxi ou location de voiture recommandés." },
    ],
  },
  gallery: {
    eyebrow: "Galerie",
    title: "L'hôtel, en images",
    all: "Tout",
    cats: { habitaciones: "Chambres", restaurante: "Restaurant", salas: "Salles de réunion", eventos: "Événements", fitness: "Salle de fitness", comunes: "Espaces communs" },
  },
  blog: {
    eyebrow: "Blog & guides",
    title: "Martorell, Barcelone et Montserrat en toute tranquillité",
    read: "min de lecture",
    readMore: "Lire l'article",
    back: "Retour au blog",
    related: "Articles liés",
    notFound: "Article introuvable",
  },
  contact: {
    eyebrow: "Contact",
    title: "Parlons de votre séjour ou de votre événement",
    text: "Nous répondons en moins de 24 heures ouvrées. Pour les réservations de chambres, utilisez notre moteur de réservation directe avec le meilleur prix garanti.",
    phone: "Téléphone",
    email: "Email",
    address: "Adresse",
    hours: "Réception 24 heures",
    formEyebrow: "Formulaire",
    formTitle: "Comment pouvons-nous vous aider ?",
  },
  form: {
    type: "Type de demande",
    types: { contacto: "Demande générale", empresa: "Tarif entreprise", salas: "Devis salles / réunions", evento: "Mariage / célébration / groupe", restaurante: "Réservation restaurant" },
    name: "Nom et prénom",
    company: "Entreprise / organisation",
    email: "Email",
    phone: "Téléphone",
    nights: "Nuits par an (env.)",
    guests: "Personnes / convives",
    date: "Date prévue",
    attendees: "Nombre de participants",
    eventType: "Type d'événement",
    eventTypes: ["Mariage", "Communion / baptême", "Anniversaire", "Réunion / formation", "Convention", "Groupe de voyage", "Autre"],
    setup: "Configuration préférée",
    setups: ["Théâtre", "Classe", "En U", "Impérial", "Cocktail", "Banquet"],
    catering: "Traiteur",
    caterings: ["Pause café", "Déjeuner d'affaires", "Dîner", "Sans traiteur"],
    lodging: "Avez-vous besoin d'un hébergement ?",
    lodgings: ["Oui", "Non", "À confirmer"],
    message: "Commentaires",
    messagePlaceholder: "Dites-nous ce dont vous avez besoin…",
    consent: "J'ai lu et j'accepte la politique de confidentialité et le traitement de mes données pour répondre à cette demande.",
    submit: "Envoyer la demande",
    sending: "Envoi…",
    success: "Demande envoyée. Nous vous répondrons sous 24 h.",
    error: "Impossible d'envoyer. Réessayez ou appelez-nous.",
    required: "Champ obligatoire",
    invalidEmail: "Email non valide",
    consentRequired: "Vous devez accepter la politique de confidentialité",
    select: "Sélectionner",
  },
  footer: {
    tagline: "Hôtel 4 étoiles à Martorell. Repos, travail et célébrations à 30 minutes de Barcelone.",
    explore: "Explorer",
    business: "Entreprises",
    guides: "Guides",
    legal: "Légal",
    contact: "Contact",
    legalNotice: "Mentions légales",
    privacy: "Confidentialité",
    cookies: "Cookies",
    cookieSettings: "Paramètres des cookies",
    rights: "Tous droits réservés.",
    registration: "Registre touristique",
    newsletter: "Recevez des offres directes",
    newsletterText: "Nous n'écrivons que lorsqu'il y a quelque chose qui en vaut la peine.",
    subscribe: "S'abonner",
    subscribed: "Merci, nous vous tiendrons informé.",
    directBook: "Réservation directe · Meilleur prix garanti",
  },
  legal: {
    legal: { title: "Mentions légales", date: "octobre 2026", sections: [
      ["Données d'identification", "Conformément à la loi 34/2002, du 11 juillet, relative aux services de la société de l'information et du commerce électronique (LSSI-CE), les informations suivantes sont communiquées :\nTitulaire : EYE STAR, S.L.\nNom commercial : Hotel Ciutat Martorell\nNIF : B87171740\nSiège social : Avda. de la Industria, 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), Espagne\nAdresse de l'établissement : Avda. Pau Claris, s/n, 08760 Martorell (Barcelone), Espagne\nTéléphone : +34 937 745 160\nAdresse e-mail : info@hotel-martorell.com\nSite web : www.hotel-martorell.com\nDonnées d'immatriculation : Registre du commerce de Madrid, Tome 32963, Folio 138, Feuille M-593334, 1re inscription."],
      ["Objet", "Les présentes mentions légales régissent l'accès, la navigation et l'utilisation du site web www.hotel-martorell.com, ainsi que les responsabilités découlant de l'utilisation de ses contenus et, le cas échéant, des services qui peuvent y être proposés.\nL'accès et la navigation sur le site web confèrent la qualité d'utilisateur et impliquent l'acceptation des conditions énoncées dans les présentes mentions légales."],
      ["Conditions d'utilisation", "L'utilisateur s'engage à utiliser le site web conformément à la législation en vigueur, à la bonne foi, à l'ordre public et aux présentes mentions légales.\nL'utilisateur doit s'abstenir d'utiliser le site web à des fins illicites ou contraires aux présentes mentions légales, ainsi que de réaliser toute action susceptible d'endommager, de rendre inutilisable, de surcharger ou de détériorer le site web, ses contenus ou les systèmes et équipements qui le supportent."],
      ["Propriété intellectuelle et industrielle", "Tous les contenus du site web, y compris, à titre indicatif et non limitatif, les textes, photographies, images, graphiques, logos, icônes, design, structure, code source et autres éléments faisant partie du site web, appartiennent à EYE STAR, S.L. ou sont utilisés avec l'autorisation correspondante de leurs titulaires légitimes.\nCes contenus sont protégés par la réglementation en vigueur en matière de propriété intellectuelle et industrielle.\nLa reproduction, la distribution, la communication publique, la transformation ou toute autre forme d'exploitation, totale ou partielle, des contenus du site web sans l'autorisation préalable et expresse d'EYE STAR, S.L. est interdite, sauf dans les cas légalement autorisés."],
      ["Responsabilité", "EYE STAR, S.L. s'efforcera de maintenir les contenus du site web corrects et à jour. Toutefois, elle ne garantit pas l'absence d'erreurs ou d'omissions et n'est pas responsable des dommages pouvant résulter de l'utilisation des informations contenues sur le site web lorsque ceux-ci sont la conséquence de circonstances indépendantes de sa volonté.\nEYE STAR, S.L. ne garantit pas non plus la disponibilité et la continuité du fonctionnement du site web, des interruptions pouvant survenir pour des raisons techniques, de maintenance ou en raison de circonstances indépendantes de sa volonté.\nLe site web peut contenir des liens vers des sites web de tiers. EYE STAR, S.L. n'assume aucune responsabilité quant aux contenus, services, fonctionnement ou politiques de confidentialité de ces sites web externes."],
      ["Protection des données personnelles", "Le traitement des données personnelles susceptibles d'être collectées via ce site web sera effectué conformément à la réglementation en vigueur en matière de protection des données personnelles.\nLes informations relatives au responsable du traitement, aux finalités du traitement, aux bases juridiques, aux destinataires, aux durées de conservation et aux droits que les utilisateurs peuvent exercer sont disponibles dans la Politique de confidentialité du site web."],
      ["Cookies", "Ce site web peut utiliser des cookies et des technologies similaires.\nLes informations relatives aux cookies utilisés, à leurs finalités, aux tiers susceptibles d'intervenir et à la manière dont l'utilisateur peut gérer ses préférences sont disponibles dans la Politique de cookies.\nLes cookies qui ne sont pas strictement nécessaires seront utilisés conformément à la réglementation applicable et, le cas échéant, après obtention du consentement de l'utilisateur."],
      ["Communications commerciales", "Lorsque l'utilisateur a donné son consentement pour recevoir des communications commerciales par voie électronique, celles-ci seront effectuées conformément à la législation en vigueur.\nL'utilisateur peut s'opposer à l'envoi de communications commerciales à tout moment au moyen des mécanismes prévus à cet effet dans chaque communication."],
      ["Modifications", "EYE STAR, S.L. se réserve le droit de modifier, mettre à jour ou supprimer, à tout moment et sans préavis, les contenus et services proposés via le site web, ainsi que les présentes mentions légales.\nLes modifications seront applicables dès leur publication sur le site web."],
      ["Loi applicable et juridiction", "La relation entre EYE STAR, S.L. et l'utilisateur sera régie par la loi espagnole.\nPour la résolution de tout litige susceptible de survenir en relation avec l'accès au site web ou son utilisation, seront compétents les tribunaux correspondant conformément à la réglementation applicable.\nLorsque l'utilisateur a la qualité de consommateur, les règles impératives relatives à la compétence juridictionnelle et à la protection des consommateurs applicables seront respectées."],
    ]},
    privacy: { title: "Politique de confidentialité", date: "18 juillet 2025", sections: [
      ["Responsable du traitement", "Raison sociale : EYE STAR SL\nNIF : B87171740\nDomaine : https://www.hotel-martorell.com/\nAdresse postale : Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)\nAdresse e-mail : administracion@hotel-martorell.com\nTéléphone : +34 937 745 160"],
      ["Protection des données", "Conformément à la réglementation en vigueur et applicable en matière de protection des données à caractère personnel, nous vous informons que vos données seront intégrées au système de traitement dont EYE STAR SL est titulaire, NIF B87171740, dont le siège social est situé Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid). Les informations sur les traitements réalisés sont fournies ci-dessous."],
      ["Gestion des réservations d'hébergement en ligne", "Finalité : enregistrement et gestion des réservations d'hébergement en ligne.\nDurée de conservation : 3 ans (Arrêté INT/1922/2003, du 3 juillet, relatif aux registres et aux fiches d'entrée des voyageurs dans les établissements hôteliers et assimilés).\nBase légale : le consentement de l'intéressé.\nDonnées de base : nom et prénom, téléphone, NIF, adresse e-mail, données économiques ou d'assurance.\nDonnées sensibles : données relatives aux mineurs.\nCommunications : si nécessaire, vos données seront communiquées à l'Agence fiscale, aux banques et caisses d'épargne, aux Forces et Corps de sécurité et aux autorités compétentes afin de respecter les obligations administratives et de sécurité établies par la réglementation applicable. La base légitimant la communication est le respect d'une loi."],
      ["Actions commerciales (formulaire web)", "Finalité : collecte, enregistrement et traitement des données pour répondre à vos demandes et/ou requêtes, ainsi que pour la publicité et la prospection commerciale.\nDurée de conservation : tant que le consentement est maintenu, sauf obligation légale.\nBase légale : le consentement de l'intéressé.\nDonnées de base : nom et prénom, adresse e-mail."],
      ["Gestion des utilisateurs du site", "Finalité : collecte, enregistrement et traitement des données de l'utilisateur.\nDurée de conservation : tant que le consentement est maintenu, sauf obligation légale.\nBase légale : le consentement de l'intéressé.\nDonnées de base : nom et prénom, adresse e-mail."],
      ["Installation de cookies", "Finalité : gestion et installation des cookies.\nDurée de conservation : tant que le consentement est maintenu.\nBase légale : le consentement de l'intéressé.\nDonnées de base : adresse e-mail, adresse IP."],
      ["Newsletter", "Finalité : gestion de l'abonnement à la newsletter afin d'effectuer les envois correspondants.\nDurée de conservation : tant que le consentement est maintenu.\nBase légale : le consentement de l'intéressé.\nDonnées de base : nom et prénom, adresse e-mail."],
      ["Gestion du formulaire web", "Finalité : répondre à vos demandes et/ou requêtes.\nDurée de conservation : tant que le consentement est maintenu.\nBase légale : le consentement de l'intéressé.\nDonnées de base : nom et prénom, adresse e-mail, adresse IP."],
      ["Droits des personnes concernées", "Vous pouvez exercer vos droits d'accès, de rectification, de limitation, de suppression, de portabilité et d'opposition au traitement de vos données à caractère personnel, ainsi que le droit de ne pas faire l'objet de décisions automatisées (y compris le profilage) et de retirer le consentement donné :\n• Accès : obtenir la confirmation que vos données sont ou non traitées et, le cas échéant, les données concernées et les informations légales sur le traitement.\n• Rectification : faire modifier les données inexactes ou incomplètes.\n• Limitation : faire limiter les finalités du traitement dans certains cas.\n• Suppression : faire supprimer vos données, sauf les exceptions prévues par le RGPD.\n• Portabilité : recevoir vos données dans un format structuré, d'usage courant et lisible par machine, et les transmettre à un autre responsable.\n• Opposition : que vos données ne soient pas traitées ou que leur traitement cesse dans les cas prévus.\n• Ne pas faire l'objet de décisions automatisées, y compris le profilage.\n• Retrait du consentement : à tout moment et gratuitement."],
      ["Exercice des droits", "Pour exercer ces droits, vous pouvez adresser un courrier à Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), à l'attention d'EYE STAR SL, ou envoyer un e-mail à administracion@hotel-martorell.com. La personne concernée doit s'identifier de manière fiable ; en cas de doute sur son identité, il pourra lui être demandé de compléter la demande. La demande peut être présentée par un représentant légal ou volontaire dûment identifié et autorisé. Le ou les droits que l'on souhaite exercer doivent être précisés, en indiquant une adresse à des fins de notification et en joignant les documents justificatifs nécessaires. Aucune information ne sera jamais fournie par téléphone."],
      ["Réclamation auprès de l'autorité de contrôle", "Vous avez le droit d'introduire une réclamation auprès de l'Agence espagnole de protection des données si vous estimez qu'un fait peut constituer un manquement à la réglementation applicable en matière de protection des données."],
      ["Mesures de sécurité", "EYE STAR SL s'engage à adopter les mesures techniques et organisationnelles nécessaires, en fonction du niveau de risque des traitements réalisés, afin de garantir l'intégrité, la confidentialité et la disponibilité des données."],
    ]},
    cookies: { title: "Politique de cookies", sections: [
      ["Que sont-elles", "Les cookies sont de petits fichiers stockés sur votre appareil lors de la navigation qui permettent de mémoriser des préférences ou de mesurer l'utilisation du site."],
      ["Cookies que nous utilisons", "Cookies techniques nécessaires au fonctionnement (langue, session d'administration et mémorisation de votre choix de cookies) et, uniquement avec votre consentement, cookies analytiques Google Analytics 4 (_ga, _ga_* ; durée maximale 13 mois) avec IP anonymisée pour comprendre l'usage du site et l'améliorer."],
      ["Tiers", "La carte Google Maps intégrée et le moteur de réservation externe peuvent installer leurs propres cookies, soumis à leurs politiques."],
      ["Comment les gérer", "Vous pouvez configurer votre navigateur pour bloquer ou supprimer les cookies. Cela peut affecter certaines fonctionnalités du site."],
      ["Gérer votre consentement", "Lors de votre première visite, vous pouvez accepter, refuser ou configurer les cookies par catégorie. Vous pouvez modifier votre choix à tout moment via le lien « Paramètres des cookies » en pied de page. Si vous refusez les cookies analytiques, Google Analytics fonctionne sans cookies (Consent Mode) et ne reçoit que des signaux anonymes."],
    ]},
    updated: "Dernière mise à jour",
  },
  consent: {
    eyebrow: "Cookies",
    title: "Votre vie privée, à votre façon",
    text: "Nous utilisons des cookies propres nécessaires et, uniquement si vous l'acceptez, des cookies analytiques (Google Analytics) pour comprendre l'usage du site et l'améliorer. Vous pouvez modifier votre choix à tout moment via « Paramètres des cookies », en pied de page.",
    more: "Politique de cookies",
    acceptAll: "Tout accepter",
    reject: "Refuser",
    configure: "Configurer",
    save: "Enregistrer la sélection",
    close: "Fermer",
    always: "Toujours actifs",
    necessary: { t: "Nécessaires", d: "Indispensables au fonctionnement du site : langue, sécurité et mémorisation de votre choix de cookies." },
    analytics: { t: "Analytiques", d: "Google Analytics avec IP anonymisée, pour mesurer les visites et améliorer le site. En cas de refus, seuls des signaux anonymes sans cookies sont envoyés." },
    marketing: { t: "Marketing", d: "Pour mesurer les campagnes et personnaliser les annonces Google. Nous n'utilisons actuellement aucun cookie de ce type." },
  },
  notFound: { title: "Page introuvable", text: "La page que vous recherchez n'existe pas ou a été déplacée.", cta: "Retour à l'accueil" },
  chat: {
    open: "Assistant de l'hôtel",
    close: "Fermer",
    title: "Assistant de l'hôtel",
    subtitle: "Réponses immédiates, 24 h/24",
    intro: "Bonjour, je suis l'assistant virtuel de l'Hotel Ciutat Martorell. Posez-moi vos questions sur les chambres, le petit-déjeuner, l'accès, les salles ou les événements.",
    placeholder: "Écrivez votre question…",
    send: "Envoyer",
    suggestions: ["À quelle heure est le petit-déjeuner ?", "Comment venir depuis Barcelone ?", "Avez-vous un parking ?"],
    human: "Vous préférez parler à une personne ?",
    call: "Appeler",
    whatsapp: "WhatsApp",
    book: "Réserver",
    error: "Je ne peux pas répondre pour le moment. Appelez-nous au",
    disclaimer: "Assistant automatique : il peut se tromper. Pour réserver, utilisez le bouton Réserver.",
  },
  admin: {
    googleLogin: "Se connecter avec Google",
    or: "ou",
    aiTranslate: "Traduire avec l'IA depuis l'ES",
    login: "Accès au panneau",
    email: "Email",
    password: "Mot de passe",
    enter: "Se connecter",
    logout: "Se déconnecter",
    panel: "Panneau de contenus",
    tabs: { nye: "Nouvel An", stats: "Statistiques", ai: "Assistant IA", leads: "Demandes", content: "Textes", rooms: "Chambres", meeting: "Salles", faqs: "FAQ", gallery: "Galerie", blog: "Blog", survey: "Durabilité", settings: "Données de l'hôtel" },
    save: "Enregistrer",
    saved: "Enregistré",
    add: "Ajouter",
    delete: "Supprimer",
    status: { nuevo: "Nouveau", en_proceso: "En cours", cerrado: "Fermé" },
    noLeads: "Aucune demande pour l'instant.",
    resend: "Renvoyer l'alerte",
    resendOk: "Alerte renvoyée à",
    resendFail: "L'alerte n'a pas pu être envoyée",
    notifySent: "Alerte email envoyée",
    notifyFailed: "L'alerte email a échoué",
    notifyUnknown: "Aucun enregistrement d'envoi",
  },
  common: {
    seeMore: "Voir plus",
    bookNow: "Réserver maintenant",
    call: "Appeler l'hôtel",
    placeholderNote: "Photographie provisoire",
  },
  pages: {
    rooms: {
      seoTitle: "Chambres à Martorell · Double et Twin de 21 m²",
      seoDesc: "Chambres Double et Twin avec Wi-Fi fibre, bureau et petit-déjeuner buffet. Double et Twin. Réservez en direct au meilleur prix.",
      heroTitle: ["Des chambres pensées", "pour un vrai repos"],
      heroText: "92 chambres conçues pour le repos absolu du voyageur d'affaires et de loisirs.",
    },
    roomDetailSuffix: "Chambres",
    corporate: {
      seoTitle: "Hôtel d'affaires et salles de réunion à Martorell",
      seoDesc: "Tarifs entreprises, 3 salles de réunion jusqu'à 180 personnes et hébergement à 5 min de SEAT-CUPRA et des zones industrielles de Martorell. Devis sous 24 h.",
      heroTitle: ["Votre base d'opérations", "dans le corridor du Llobregat"],
    },
    meetingRooms: {
      seoTitle: "Salles de réunion et d'événements à Martorell",
      seoDesc: "3 salles avec lumière naturelle de 35 à 220 m² pour réunions, formations et conventions de 12 à 180 personnes. Audiovisuel, fibre et pause café.",
      heroTitle: ["Trois salles,", "configurations infinies"],
    },
    events: {
      seoTitle: "Mariages, célébrations et groupes à Martorell",
      heroTitle: ["Les grands jours méritent", "un lieu à la hauteur"],
      stepsTitle: "Trois étapes, zéro souci",
    },
    restaurant: {
      seoTitle: "Restaurant à Martorell · Cuisine méditerranéenne",
      heroTitle: ["Cuisine méditerranéenne", "de marché"],
    },
    location: {
      seoTitle: "Emplacement · Hôtel à Martorell à 30 min de Barcelone",
      heroTitle: ["Au centre de tout", "ce qui compte"],
      distancesTitle: "Distances et temps",
    },
    gallery: {
      seoDesc: "Photographies de l'Hotel Ciutat Martorell 4★ à Martorell : chambres Double et Twin, salles de bain, salles de réunion, Salle de Banquet, restaurant My Bar, espaces communs et alentours.",
      biosphereNote: "L'Hotel Ciutat Martorell détient la certification Biosphere de tourisme durable. Découvrez toutes nos actions et engagements en matière de durabilité directement sur notre profil officiel.",
    },
    blog: { seoDesc: "Guides pratiques sur Martorell, Barcelone et Montserrat : venir en train ou en voiture, que visiter, où manger et conseils pour voyageurs d'affaires et familles." },
    faq: { eyebrow: "Questions fréquentes", home: "Ce que l'on nous demande souvent", rooms: "À propos des chambres", corporate: "À propos des réunions et séjours d'affaires", events: "À propos des mariages, fêtes et groupes", restaurant: "À propos du restaurant" },
    biosphere: { seoTitle: "Durabilité · Certification Biosphere" },
    contact: { hoursValue: "Check-in 15h00 · Check-out 12h00" },
    seal: { sustainableTourism: "Tourisme durable", certifiedBy: "Certifié par", viewCert: "Voir la certification" },
    bookingCta: {
      eyebrow: "Réservation directe",
      rooms: { title: "Réservez au meilleur prix garanti", text: "En réservant directement sur le site officiel, vous obtenez le meilleur tarif, sans intermédiaires ni commissions." },
      location: { title: "À 30 minutes de Barcelone et Montserrat", text: "Séjournez à côté des gares Renfe et FGC, avec l'aéroport à 30 minutes. Réservez en direct au meilleur prix garanti." },
    },
    blogPost: {
      sidebarTitle: "Dormez à 100 m du train",
      cta: {
        eyebrow: "Réservation directe",
        secondary: "Demander un devis",
        transport: { title: "Dormez à 100 m du train", text: "Séjournez à côté des gares Renfe et FGC et rejoignez Barcelone en 30 minutes. Meilleur prix garanti sur le site officiel." },
        guides: { title: "Votre base pour découvrir Martorell", text: "Barcelone, Montserrat et l'aéroport à 30 minutes. Réservez en direct et planifiez votre escapade." },
        business: { title: "Hébergement et salles pour votre entreprise", text: "À 5 minutes de la zone industrielle, avec salles de réunion et tarif entreprise. Demandez-nous un devis sur mesure." },
        default: { title: "Réservez votre séjour à Martorell", text: "Hôtel 4★ à 30 minutes de Barcelone. Meilleur prix garanti en réservant en direct." },
      },
    },
    homeHeadings: {
      presentation: ["Hôtel 4 étoiles à Martorell.", "Repos, travail et célébrations", "à 30 minutes de Barcelone."],
      gastronomy: ["Cuisine méditerranéenne", "de marché, sans hâte"],
      extras: ["Un événement, une réunion", "ou un long séjour ?"],
      heroRooms: "Chambres",
    },
  },
};

export default fr;
